// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".small-box-footer>a[data-v-cc385968]{color:inherit}", "",{"version":3,"sources":["/home/zhaochang/devspace/changba-ui/packages/small-box/src/small-box.vue"],"names":[],"mappings":"AAmEE,qCACE,aAAA","file":"small-box.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.small-box-footer {\n  > a {\n    color: inherit;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
